import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const getAllProjectPhasesSelector = ()=>createSelector((state)=>state.templates.project, (_, templateId)=>templateId, (project, templateId)=>project.data[templateId].projectPhases);
export const useGetAllProjectPhases = ()=>{
    const templateId = useActiveTemplateId();
    const templateObject = useMemo(getAllProjectPhasesSelector, []);
    return useSelector((state)=>templateObject(state, templateId));
};
